
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/*
When the text fields data is changed,
the target fields name is used as the state variable name and
the target fields value is used as the state variables value
 */
export const onDataChange = function (event) {
    this.setState({ [event.target.name]: event.target.value });
};


/*****************************************************************
            Validations
****************************************************************/

/*
The method will add an error {key:value} pair to the errorMap state value.
If there is an existing key, the value will be updated
 */
function addErrorMap(obj, key, value) {
    let errorMap = obj.state.errorMap;
    errorMap.set(key, value);
    obj.setState({ errorMap: errorMap });
}

/*
The method will remove an error {key:value} pair to the errorMap state value.
Based on the key the value will be removed from the map
 */
function removeErrorMap(obj, key) {
    let errorMap = obj.state.errorMap;
    if (errorMap.has(key)) {
        errorMap.delete(key);
    }
    obj.setState({ errorMap: errorMap });
}

/*
The method is used to check that user has entered their name/child name
 */
export const validateName = function () {
    if (this.state.name === "") {
        addErrorMap(this, "nameError", "Please enter the name");
    } else {
        removeErrorMap(this, "nameError");
    }
};

/*
The method is used to check that user has entered correct email address
 */
export const validateEmail = function () {
    if (this.state.email === "") {
        addErrorMap(this, "emailError", "Please enter the email address");
    } else {
        if (emailRegex.test(String(this.state.email).toLowerCase())) {
            removeErrorMap(this, "emailError");
        } else {
            addErrorMap(this, "emailError", "Please enter valid email address");
        }
    }
};

/*
The method is used to check that user has selected the relationship value
 */
export const validateRelationship = function () {
    if (this.state.relationship === "") {
        addErrorMap(this, "relationshipError", "Please select the valid relationship");
    } else {
        removeErrorMap(this, "relationshipError");
    }
};

/*
The validation to be performed on the guardian onboarding form.
 */
export const guardianValidate = function()
  {
        validateName.bind(this)();
        validateEmail.bind(this)();
        validateRelationship.bind(this)();

        if (this.state.errorMap.size !== 0) {
            this.setState({pageError: "Resolve the errors to continue"});
            return false;
        }
        return true;
  };


/*****************************************************************
            Creating Form and Axios Call
****************************************************************/

export const createGuardianFormData = function()
  {
    let formData = new FormData();
    formData.append("full_name", this.state.name);
    formData.append("email", this.state.email);
    formData.append("relationship", this.state.relationship);
    return formData;
  };
